export default __webpack_public_path__ + "static/media/BA95N.a83a7dce.svg";